import styled from "styled-components";

export const Container = styled.div`
  text-align: center;
  margin: 2em;
`;

export const Icon = styled.div`
  font-size: 2.5em;
`;

export const TimeRemaining = styled.div`
  font-size: 1.5em;
`;
